import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ProductTabMobile = ({ selectedHall }) => {
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;


    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    const handleHallSelection = (hallName) => {
        setIsAccordionOpen(false);
        // Navigate to the corresponding mobile sale page
        switch (hallName) {
            case '상품안내':
                navigate('/mutual-assistance-product-info');
                break;
            case '서비스 장점':
                navigate('/service-advantages');
                break;
            case '행사절차':
                navigate('/event-procedure');
                break;
            default:
                break;
        }
    };

    return (
        <div>
            {/* First Accordion - Hall Selection */}
            <div className="sky-hall-special-room-mobile-accordion">
                <div
                    className="sky-hall-special-room-mobile-accordion-header"
                    onClick={toggleAccordion}
                    style={{
                        backgroundImage: 'url(/images mobile directions/36_765.svg)',
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    <h3>{selectedHall}</h3>
                    <img
                        src="/images mobile directions/7202ea909cb877a6a9c4abd27098600d577ca10d.png"
                        alt="Toggle"
                        className={`sky-hall-special-room-mobile-accordion-toggle ${isAccordionOpen ? 'open' : ''}`}
                    />
                </div>

                {/* First Accordion Dropdown Content */}
                {isAccordionOpen && (
                    <div className="sky-hall-special-room-mobile-accordion-content">
                        <div className="sky-hall-special-room-mobile-hall-grid">
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/mutual-assistance-product-info' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('상품안내')}
                            >
                                상품안내
                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/service-advantages' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('서비스 장점')}
                            >
                                서비스 장점
                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/event-procedure' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('행사절차')}
                            >
                                행사절차
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductTabMobile;

